import { string } from 'yup';
export const generateTextSchemaObject = ({ required }) => {
    let fieldValidation = string();
    if (required) {
        fieldValidation = fieldValidation.required('This is a required field');
    }
    return fieldValidation;
};
